import { authService } from '@/services/auth.service';
import { useAuthStore } from '@/store/auth.store';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const useAdminAuthGuard = () => {
  const navigate = useNavigate();
  const setAuth = useAuthStore((state) => state.setAuth);
  const logout = useAuthStore((state) => state.logout);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const finish = () => {
      if (isMounted) {
        setIsChecking(false);
      }
    };

    void authService
      .getMe()
      .then((user) => {
        if (!isMounted) {
          return;
        }

        setAuth(user);
        finish();
      })
      .catch(() => {
        if (!isMounted) {
          return;
        }

        void authService
          .logout()
          .catch(() => undefined)
          .finally(() => {
            logout();
            void navigate('/admin/login', { replace: true });
            finish();
          });
      });

    return () => {
      isMounted = false;
    };
  }, [logout, navigate, setAuth]);

  return { isChecking };
};
